function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgSidebarHeadset(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M13.995 4.544C13.704 3.472 12.464 0 7.982 0 3.535 0 2.26 3.473 2.005 4.544 1.167 4.876 0 5.763 0 7.5c0 1.7 1.167 2.66 1.968 3.03.11.665.437 2.143 1.859 3.03 1.02.664 2.26.812 3.097.849.182.369.547.591.949.591.619 0 1.093-.48 1.093-1.108 0-.591-.474-1.109-1.093-1.109-.438 0-.802.259-.985.665-.728-.037-1.75-.184-2.587-.702-1.349-.85-1.422-2.512-1.422-2.586V4.987c.073-.443.875-3.99 5.103-3.99 4.227 0 5.03 3.583 5.102 3.99v5.21c0 .147.073.295.182.406a.41.41 0 00.292.11c.036 0 .109 0 .145-.037.803-.258 2.297-1.218 2.297-3.14 0-1.773-1.203-2.66-2.005-2.992",
    fill: "#0A1633",
    fillRule: "evenodd"
  }));
}

SvgSidebarHeadset.clsName = 'icon-www__sidebar_headset';
SvgSidebarHeadset.remarkName = 'unknown';
export default SvgSidebarHeadset;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/SidebarHeadset.js
// module id = 2432
// module chunks = 17 18